import {
  type EnvironmentSettingsWithApi,
  useAuthenticationContext,
} from '@festina-life/authentication'
import {
  BuildInfo,
  DarkModeSwitcher,
  Settings,
  useSettingsContext,
} from '@festina-life/components'
import { IconButton } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'
import { FestinaLogo, FestinaLogoDarkMode } from '@festina-life/ui/icons'
import {
  Dropdown,
  Icon,
  Logo,
  TopBar as FestinaUiTopBar,
} from '@festina-life/ui/structure'
import { useState } from 'react'
// oxlint-disable-next-line no-restricted-imports -- kept to not break too many things in the config portal
import { Link } from 'react-router'

import { buildInfo } from '../../system/buildInfo'
import { server as serverPath } from '../../system/paths'
import { useNavigationParams } from '../../system/useNavigationParams'
import { useWorkspaceManagerContext } from '../../workspace/workspaceManagerContext'
import { ChangelogModalButton } from '../changelog/ChangelogModalButton'
import { SubmitFeedbackModalButton } from '../feedback/SubmitFeedbackModalButton'
import { ViewAtDatePicker } from '../viewAtPicker/ViewAtDatePicker'
import { ConfigurationPersonaSelector } from './ConfigurationPersonaSelector'

export const TopBar = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const translate = useTranslate()
  const { block, branch, server } = useNavigationParams()
  const { currentWorkspaceKey } = useWorkspaceManagerContext()
  const {
    authState: { accounts, logout },
  } = useSettingsContext()
  const {
    environmentSettings,
    onChangeEnvironmentSettings,
    api,
    isInTestMode,
  } = useAuthenticationContext()

  const handleChangeSettings = (nextSettings: EnvironmentSettingsWithApi) => {
    onChangeEnvironmentSettings(nextSettings)
  }

  return (
    <>
      <Settings
        value={{ ...environmentSettings!, api }}
        onChange={handleChangeSettings}
        isModalOpen={isModalOpen}
        onCloseModal={() => setIsModalOpen(false)}
      />
      <FestinaUiTopBar
        logo={
          <Link
            to={serverPath({
              server,
              workspaceName: currentWorkspaceKey?.name,
              branch,
              block,
            })}
            className="px-1"
          >
            <Logo
              images={{
                dark: FestinaLogoDarkMode,
                light: FestinaLogo,
              }}
            />
          </Link>
        }
        title={translate('app.title')}
        childrenLeft={<ConfigurationPersonaSelector />}
        childrenRight={
          <div className="flex justify-end items-center gap-x-2">
            <SubmitFeedbackModalButton />
            <ChangelogModalButton />
            <ViewAtDatePicker />
            {isInTestMode && (
              <IconButton
                onClick={() => setIsModalOpen(true)}
                tip={null}
                iconName="Cog"
                iconSize="md"
              />
            )}
            <Dropdown
              element={<IconButton tip={null} iconName="User" iconSize="md" />}
              items={[
                {
                  element: <p>{accounts[0].username.toLocaleLowerCase()}</p>,
                },
                {
                  element: (
                    <div className="flex gap-x-2 items-center">
                      <Icon name="ArrowRightStartOnRectangle" />
                      <p>{translate('signout')}</p>
                    </div>
                  ),
                  onClick: () => logout(),
                },
                {
                  element: <DarkModeSwitcher />,
                },
                {
                  element: (
                    <BuildInfo
                      className="relative!"
                      buildNo={buildInfo.buildNo}
                      buildTime={buildInfo.buildTime}
                    />
                  ),
                },
              ]}
            />
          </div>
        }
      />
    </>
  )
}
